(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cms-full-bleed-quote"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.cms-full-bleed-quote').forEach(function (section) {
  var img = section.querySelector('.bleed-img');
  var rm = matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!img || rm) return;
  var ticking = false;
  addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var r = section.getBoundingClientRect();
      if (r.bottom > 0 && r.top < innerHeight) {
        img.style.transform = 'translateY(' + ((r.top + r.height / 2 - innerHeight / 2) * -0.08) + 'px)';
      }
    });
  }, { passive: true });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cms-home-hero"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.cms-home-hero').forEach(function (hero) {
  window.addEventListener('load', function () {
    hero.classList.add('is-loaded');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cms-size-finder"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.cms-size-finder').forEach(function (root) {
  var track = root.querySelector('.sizer-track');
  if (!track) return;
  var sizes = JSON.parse(track.getAttribute('data-sizes') || '[]');
  if (!sizes.length) return;

  var handle = root.querySelector('.sizer-handle');
  var fill = root.querySelector('.sizer-fill');
  var valueEl = root.querySelector('.sizer-readout .num');
  var cabCard = root.querySelector('[data-role="cab"]');
  var drwCard = root.querySelector('[data-role="drw"]');
  var cabLabel = cabCard ? cabCard.querySelector('.v') : null;
  var drwLabel = drwCard ? drwCard.querySelector('.v') : null;
  var tickLabels = root.querySelectorAll('.sizer-tick-label');
  var fitsTemplate = root.getAttribute('data-fits-template') || 'Fits {n}″ openings';
  var notMadeLabel = root.getAttribute('data-not-made-label') || 'Not made at this size';
  var defaultInches = parseFloat(root.getAttribute('data-default-inches'));

  var MIN = sizes[0].n;
  var MAX = sizes[sizes.length - 1].n;

  function pctForValue(v) {
    return (v - MIN) / (MAX - MIN) * 100;
  }
  function nearestIdx(value) {
    var best = 0, bd = Infinity;
    sizes.forEach(function (s, i) {
      var d = Math.abs(s.n - value);
      if (d < bd) { bd = d; best = i; }
    });
    return best;
  }
  function valueFromClientX(clientX) {
    var rect = track.getBoundingClientRect();
    var pct = (clientX - rect.left) / rect.width;
    pct = Math.max(0, Math.min(1, pct));
    return MIN + pct * (MAX - MIN);
  }
  function render(idx) {
    var s = sizes[idx];
    var pct = pctForValue(s.n);
    handle.style.left = pct + '%';
    fill.style.width = pct + '%';
    handle.setAttribute('aria-valuenow', s.n);
    if (valueEl) valueEl.textContent = s.n;
    tickLabels.forEach(function (el) {
      el.classList.toggle('active', +el.dataset.n === s.n);
    });
    if (cabCard) {
      if (s.cab) {
        cabCard.setAttribute('href', s.cab);
        cabCard.classList.remove('disabled');
        if (cabLabel) cabLabel.textContent = fitsTemplate.replace('{n}', s.n);
      } else {
        cabCard.removeAttribute('href');
        cabCard.classList.add('disabled');
        if (cabLabel) cabLabel.textContent = notMadeLabel;
      }
    }
    if (drwCard && s.drw) {
      drwCard.setAttribute('href', s.drw);
      if (drwLabel) drwLabel.textContent = fitsTemplate.replace('{n}', s.n);
    }
  }

  var dragging = false;
  handle.addEventListener('pointerdown', function (e) {
    dragging = true;
    handle.setPointerCapture(e.pointerId);
  });
  window.addEventListener('pointermove', function (e) {
    if (dragging) render(nearestIdx(valueFromClientX(e.clientX)));
  });
  window.addEventListener('pointerup', function () {
    dragging = false;
  });
  track.addEventListener('click', function (e) {
    if (e.target !== track) return;
    render(nearestIdx(valueFromClientX(e.clientX)));
  });
  handle.addEventListener('keydown', function (e) {
    var cur = sizes.findIndex(function (s) {
      return s.n === +handle.getAttribute('aria-valuenow');
    });
    if (e.key === 'ArrowRight' || e.key === 'ArrowUp') {
      render(Math.min(sizes.length - 1, cur + 1));
      e.preventDefault();
    }
    if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') {
      render(Math.max(0, cur - 1));
      e.preventDefault();
    }
  });
  tickLabels.forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.stopPropagation();
      render(sizes.findIndex(function (s) {
        return s.n === +el.dataset.n;
      }));
    });
  });

  var initialIdx = sizes.findIndex(function (s) { return s.n === defaultInches; });
  if (initialIdx < 0) initialIdx = Math.floor(sizes.length / 2);
  render(initialIdx);
});

  } catch(e) { console.error(e); }
})();
})();
